<!-- TOP BAR -->
<div class="ums-topbar">
  <button class="hamburger" (click)="navOpen = !navOpen" title="Toggle navigation">☰</button>
  <div class="logo">KBM</div>
  <div class="ctx-wrap" style="position:relative;display:inline-block;">
    <button class="ctx" (click)="ctxDropOpen = !ctxDropOpen">{{ contextName }} ▾</button>
    <div *ngIf="ctxDropOpen" class="ctx-dropdown" style="position:absolute;top:100%;left:0;background:#fff;border:1px solid #e5e7eb;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,.12);z-index:200;min-width:160px;">
      <div *ngFor="let item of contextItems"
           class="ctx-opt"
           style="padding:8px 16px;cursor:pointer;font-size:13px;"
           (click)="switchContext(+item.mailbox.substring(4)); ctxDropOpen = false">
        {{ item.label }}
      </div>
    </div>
  </div>
  <div class="search">
    <span class="ico">🔍</span>
    <input [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" placeholder="Search messages, guests, reservations…">
    <button *ngIf="searchQuery" class="search-clear" (click)="searchQuery = ''; onSearchChange()" title="Clear search">×</button>
  </div>
  <div class="view-toggle">
    <button [class.on]="activeView === 'conversation'" (click)="setView('conversation')">Conversation</button>
    <button [class.on]="activeView === 'all'" (click)="setView('all')">All Messages</button>
  </div>
  <button class="ghost" (click)="filtersOpen = !filtersOpen">Filters ▾</button>
  <button class="ums-btn" (click)="openCompose()">+ Compose</button>
  <div class="bell">🔔<span class="dot" *ngIf="hasUnread"></span></div>
  <a [routerLink]="['/task-list']" class="followup-badge" *ngIf="followupCount > 0" title="Follow-ups due today">
    {{ followupCount }} follow-up{{ followupCount === 1 ? '' : 's' }} due today
  </a>
</div>

<!-- FILTERS PANEL -->
<div class="ums-filters-panel" *ngIf="filtersOpen">
  <div class="fp-row">
    <label>Channel</label>
    <select [(ngModel)]="filterChannel">
      <option value="">All</option>
      <option value="EMAIL">Email</option>
      <option value="SMS">SMS</option>
      <option value="OTA">OTA</option>
      <option value="NOTE">Note</option>
    </select>
  </div>
  <div class="fp-row">
    <label>Status</label>
    <select [(ngModel)]="filterStatus">
      <option value="">All</option>
      <option value="unread">Unread</option>
      <option value="read">Read</option>
    </select>
  </div>
  <div class="fp-actions">
    <button class="ums-btn" (click)="applyFilters()">Apply</button>
    <button class="ghost" (click)="clearFilters()">Clear</button>
  </div>
</div>

<!-- COMPOSE PANEL -->
<div class="ums-compose-panel" *ngIf="composingNew">
  <div class="cp-header">
    <span class="cp-title">New Message</span>
    <button class="cp-close" (click)="composingNew = false" title="Close">×</button>
  </div>
  <div class="cp-body">
    <div class="cp-field">
      <label>To</label>
      <input type="email" [(ngModel)]="composeTo" placeholder="recipient@example.com">
    </div>
    <div class="cp-field">
      <label>Subject</label>
      <input type="text" [(ngModel)]="composeSubject" placeholder="Subject">
    </div>
    <div class="cp-field">
      <label>Message</label>
      <textarea [(ngModel)]="composeBody" rows="6" placeholder="Type your message…"></textarea>
    </div>
    <div *ngIf="composeError" class="cp-error">{{ composeError }}</div>
    <div class="cp-actions">
      <button class="ums-btn" (click)="sendCompose()" [disabled]="composeSending">
        {{ composeSending ? 'Sending…' : 'Send' }}
      </button>
      <button class="ghost" (click)="composingNew = false">Cancel</button>
    </div>
  </div>
</div>

<!-- LAYOUT -->
<div class="ums-layout">

  <!-- LEFT NAV -->
  <aside class="ums-nav" [class.collapsed]="!navOpen">
    <div class="group">Mailboxes</div>
    <div *ngFor="let item of mailboxItems"
         class="item"
         [class.active]="item.active"
         (click)="setMailbox(item.mailbox)">
      {{ item.icon }} {{ item.label }}
      <span *ngIf="item.count" class="cnt">{{ item.count }}</span>
    </div>

    <div class="group">Contexts</div>
    <div *ngFor="let item of contextItems"
         class="item"
         [class.active]="activeMailbox === item.mailbox"
         (click)="setMailbox(item.mailbox)">
      {{ item.label }}
      <span *ngIf="item.count" class="cnt">{{ item.count }}</span>
    </div>

    <div class="group">Labels (Flags)</div>
    <div *ngFor="let lbl of labelItems"
         class="item"
         [class.active]="activeNavLabel === lbl.label"
         (click)="filterByLabel(lbl.label)">
      <span class="label-dot" [style.background]="lbl.color"></span>
      {{ lbl.label }}
      <span *ngIf="lbl.count" class="cnt">{{ lbl.count }}</span>
    </div>
    <div class="item" style="color:var(--muted);font-size:12px;cursor:pointer;" (click)="openManageLabels()">+ Manage labels…</div>

    <div class="group">Channels</div>
    <div class="item" [class.active]="activeNavChannel === 'SMS'" (click)="filterByChannel('SMS')">💬 SMS</div>
    <div class="item" [class.active]="activeNavChannel === 'EMAIL'" (click)="filterByChannel('EMAIL')">✉️ Email</div>
    <div class="item" [class.active]="activeNavChannel === 'SYSTEM'" (click)="filterByChannel('SYSTEM')">⚙️ System &amp; Automated</div>

    <div class="group">Properties</div>
    <div class="item" [class.active]="activeNavProperty === 'Maui'" (click)="filterByProperty('Maui')">🌴 Maui</div>
    <div class="item" [class.active]="activeNavProperty === 'ParkCity'" (click)="filterByProperty('ParkCity')">⛷ Park City</div>
  </aside>
  <div class="ums-resize-handle" (mousedown)="startResize($event, 'nav')" title="Drag to resize"></div>

  <!-- CONVERSATION LIST COLUMN -->
  <aside class="ums-convlist">
    <div class="cl-header">
      <input type="checkbox" class="cl-check-all"
             [checked]="allSelected"
             (change)="allSelected ? clearSelection() : selectAll()">
      <span class="cl-title">{{ contextName }}</span>
      <span class="cl-count">{{ conversations.length }}</span>
    </div>

    <!-- OPENSEARCH RESULTS PANEL (visible when query >= 3 chars) -->
    <div class="ums-search-results" *ngIf="searchQuery.length >= 3">
      <div class="sr-header">
        <span>Search Results</span>
        <span *ngIf="searchLoading" class="sr-loading">Searching…</span>
        <span *ngIf="!searchLoading" class="sr-count">{{ searchResults.length }} found</span>
      </div>
      <div *ngIf="searchError" class="sr-error">{{ searchError }}</div>
      <div *ngIf="!searchLoading && searchResults.length === 0 && !searchError" class="sr-empty">No results.</div>
      <div *ngFor="let result of searchResults" class="sr-row" (click)="selectSearchResult(result)">
        <span class="sr-sender">{{ result.senderName || result.senderEmail || 'Unknown' }}</span>
        <span class="sr-subject">{{ result.subject || '(no subject)' }}</span>
        <span class="sr-date">{{ formatConvDate(result.sentDate || result.createDate) }}</span>
        <div class="sr-preview">{{ (result.bodyPreview || result.emailText || '') | slice:0:120 }}</div>
      </div>
    </div>

    <!-- QUICK-FILTER CHIPS -->
    <div class="quick-filters">
      <button class="qf-chip" [class.active]="activeQuickFilter === 'all'" (click)="setQuickFilter('all')">All</button>
      <button class="qf-chip" [class.active]="activeQuickFilter === 'new-mail'" (click)="setQuickFilter('new-mail')">New Mail</button>
      <button class="qf-chip qf-followup" [class.active]="activeQuickFilter === 'follow-ups'" (click)="setQuickFilter('follow-ups')">Follow-ups</button>
    </div>

    <div class="bulk-bar" *ngIf="someSelected">
      <span class="bulk-count">{{ selectedConvIds.size }} selected</span>
      <button class="bulk-btn" (click)="bulkMarkRead()">Mark Read</button>
      <div style="position:relative;display:inline-block;">
        <button class="bulk-btn" (click)="showBulkLabelMenu = !showBulkLabelMenu">Label ▾</button>
        <div *ngIf="showBulkLabelMenu" class="bulk-label-menu">
          <button *ngFor="let lbl of availableLabels"
            (click)="bulkLabel(lbl); showBulkLabelMenu=false"
            class="bulk-label-opt">{{ lbl }}</button>
        </div>
      </div>
      <button class="bulk-btn ghost" (click)="clearSelection()">Clear</button>
    </div>

    <div *ngIf="convLoading" class="cl-empty">Loading…</div>
    <div *ngIf="!convLoading && convError" class="cl-empty cl-error">{{ convError }}</div>
    <div *ngIf="!convLoading && !convError && filteredConversations.length === 0" class="cl-empty">No conversations yet.</div>

    <div *ngFor="let conv of filteredConversations"
         class="cl-row"
         [class.active]="conv.conversationId === activeConversationId"
         (click)="selectConversation(conv)">
      <div class="cl-row-top">
        <input type="checkbox" class="cl-check"
               [checked]="isSelected(conv)"
               (click)="toggleSelection(conv, $event)">
        <span class="cl-unread-dot" *ngIf="isConvUnread(conv)"></span>
        <span class="cl-sender" [title]="conv.lastSenderEmail">{{ senderLabel(conv) }}</span>
        <!-- Fix 4: Channel badge chip -->
        <span class="cl-channel-badge" [ngClass]="channelBadgeClass(conv)">{{ channelBadgeLabel(conv) }}</span>
        <!-- Unread mail badge -->
        <span class="cl-badge cl-badge-new" *ngIf="isConvUnread(conv) && !conv.isTask">NEW</span>
        <!-- Urgency badges (non-task messages only) -->
        <span class="cl-urgency urgent" *ngIf="!conv.isTask && getUrgency(conv) === 'urgent'">URGENT</span>
        <span class="cl-urgency high" *ngIf="!conv.isTask && getUrgency(conv) === 'high'">HIGH</span>
        <!-- Task badges -->
        <span class="cl-badge cl-badge-overdue" *ngIf="conv.isTask && conv.isOverdue">OVERDUE</span>
        <span class="cl-badge cl-badge-followup" *ngIf="conv.isTask && !conv.isOverdue">FOLLOW-UP</span>
        <span class="cl-date">{{ formatConvDate(conv.lastDate) }}</span>
      </div>
      <div class="cl-subject" *ngIf="cleanSubject(conv.lastSubject)">{{ cleanSubject(conv.lastSubject) }}</div>
      <!-- Fix 5: Property code + check-in date secondary line (requires backend to add fields) -->
      <div class="cl-property-line" *ngIf="convPropertyLine(conv)">{{ convPropertyLine(conv) }}</div>
      <div class="cl-preview">{{ conv.lastBodyPreview }}</div>
      <div class="cl-meta" *ngIf="conv.msgCount > 1">{{ conv.msgCount }} messages</div>
      <div class="cl-labels" *ngIf="convLabels[conv.conversationId]?.length">
        <span *ngFor="let lbl of convLabels[conv.conversationId]" class="cl-lbl">{{ lbl }}</span>
      </div>
    </div>

    <div *ngIf="hasMore && !convLoading" class="cl-load-more">
      <button class="cl-load-more-btn" (click)="loadMore()" [disabled]="convLoadingMore">
        {{ convLoadingMore ? 'Loading…' : 'Load more' }}
      </button>
    </div>
    <div *ngIf="!convLoading && !convLoadingMore && !hasMore && conversations.length > 0" class="cl-load-more">
      <button class="cl-load-more-btn" (click)="loadOlder()" [disabled]="convLoadingMore">
        Load older (past year)
      </button>
    </div>
  </aside>
  <div class="ums-resize-handle" (mousedown)="startResize($event, 'conv')" title="Drag to resize"></div>

  <!-- CENTER: TASK DETAIL PANEL (shown when a task row with no linked conversation is clicked) -->
  <ng-container *ngIf="activeTaskDetail">
    <div class="ums-task-detail">
      <div class="td-header">
        <span class="td-badge" [class.overdue]="activeTaskDetail.overdue">
          {{ activeTaskDetail.overdue ? 'OVERDUE' : 'FOLLOW-UP' }}
        </span>
        <span class="td-title">{{ activeTaskDetail.name }}</span>
      </div>
      <div class="td-meta">
        <div class="td-row" *ngIf="activeTaskDetail.assignedToUserName">
          <span class="td-label">Assigned to</span>
          <span>{{ activeTaskDetail.assignedToUserName }}</span>
        </div>
        <div class="td-row">
          <span class="td-label">Status</span>
          <span>{{ activeTaskDetail.statusLabel }}</span>
        </div>
        <div class="td-row" *ngIf="activeTaskDetail.dateToFollowup">
          <span class="td-label">Follow-up date</span>
          <span>{{ activeTaskDetail.dateToFollowup }}</span>
        </div>
        <div class="td-row" *ngIf="activeTaskDetail.dateDue">
          <span class="td-label">Due date</span>
          <span>{{ activeTaskDetail.dateDue }}</span>
        </div>
        <div class="td-row" *ngIf="activeTaskDetail.guestName">
          <span class="td-label">Guest</span>
          <span>{{ activeTaskDetail.guestName }}</span>
        </div>
      </div>
      <div class="td-description" *ngIf="activeTaskDetail.description">
        <p>{{ activeTaskDetail.description }}</p>
      </div>
      <div class="td-actions">
        <a class="ums-btn" [routerLink]="['/task-list']" [queryParams]="{taskId: activeTaskDetail.taskId}" target="_blank">Open in Tasks</a>
        <button class="ghost" (click)="activeTaskDetail = null">Dismiss</button>
      </div>
    </div>
  </ng-container>

  <!-- CENTER: CONVERSATION VIEW -->
  <ng-container *ngIf="activeView === 'conversation' && !activeTaskDetail">
    <div class="ums-empty-state" *ngIf="!activeConversationId">Select a conversation to view messages and reply</div>
    <app-unified-thread
      [conversationId]="activeConversationId"
      [context]="context"
      [contact]="contact"
      [reservations]="guestReservations"
      [availableLabels]="availableLabels"
      (guestIdentified)="onGuestIdentified($event)"
      (labelToggled)="toggleLabel(activeConversationId, $event)"
      (conversationArchived)="onConversationArchived($event)">
    </app-unified-thread>
  </ng-container>

  <!-- CENTER: ALL MESSAGES VIEW -->
  <ng-container *ngIf="activeView === 'all'">
    <app-all-messages-list [context]="context"></app-all-messages-list>
  </ng-container>

  <!-- RIGHT RAIL -->
  <!-- Fix 1: Only show the empty-state "select a conversation" message when no conversation is
       selected. When a conversation IS selected but the contact hasn't been identified yet
       (e.g. system-only messages with no guest email), pass a null contact to the pane so it
       renders its loading/no-contact placeholder, not the global empty state. -->
  <ng-container *ngIf="!activeConversationId && !activeTaskDetail">
    <div class="ums-right-empty">Select a conversation to view guest details.</div>
  </ng-container>
  <ng-container *ngIf="activeConversationId || activeTaskDetail">
    <app-guest-history-pane
      [contact]="contact"
      [reservations]="guestReservations"
      [quotes]="guestQuotes"
      [orders]="guestOrders"
      [tasks]="guestTasks">
    </app-guest-history-pane>
  </ng-container>

</div>

<!-- MANAGE LABELS DIALOG (H10) -->
<div class="ums-modal-backdrop" *ngIf="manageLabelsOpen" (click)="closeManageLabels()" style="position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:300;display:flex;align-items:center;justify-content:center;">
  <div class="ums-manage-labels-dialog" (click)="$event.stopPropagation()" style="background:#fff;border-radius:8px;padding:24px;min-width:320px;max-width:420px;box-shadow:0 8px 32px rgba(0,0,0,.18);">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;">
      <strong style="font-size:15px;">Manage Labels</strong>
      <button style="background:none;border:none;font-size:18px;cursor:pointer;" (click)="closeManageLabels()" title="Close">×</button>
    </div>
    <div *ngFor="let lbl of labelItems" style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
      <span class="label-dot" [style.background]="lbl.color" style="width:10px;height:10px;border-radius:50%;flex-shrink:0;"></span>
      <span style="flex:1;font-size:13px;">{{ lbl.label }}</span>
      <button style="background:none;border:none;color:#e04e4e;cursor:pointer;font-size:12px;" (click)="deleteManagedLabel(lbl.label)" title="Delete label">Remove</button>
    </div>
    <div style="display:flex;gap:8px;margin-top:16px;">
      <input [(ngModel)]="manageLabelNewName" placeholder="New label name…" style="flex:1;padding:6px 8px;border:1px solid #d1d5db;border-radius:4px;font-size:13px;" (keyup.enter)="addManagedLabel()">
      <button class="ums-btn" (click)="addManagedLabel()" style="white-space:nowrap;">Add</button>
    </div>
  </div>
</div>
